import { BUILD_DATE } from '@/lib/config'
import Event from '@bugsnag/core/types/event'

let instance: any = null

export const getBugsnagClient = () => {
  if (typeof window === 'undefined' || !process.env.NEXT_PUBLIC_BUGSNAG_API_KEY) {
    return null
  }

  if (instance) {
    return instance
  }

  const Bugsnag = require('@bugsnag/js')

  if (!Bugsnag._client) {
    console.debug('Starting Bugsnag...')

    Bugsnag.start({
      apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
      releaseStage: process.env.NODE_ENV,
      enabledReleaseStages: ['production'],
      appVersion: BUILD_DATE,
      endpoints: {
        notify: 'https://bs-notify.productioncrate.com',
        sessions: 'https://bs-sessions.productioncrate.com',
      },
      onError: (event: Event) => {
        console.error('Error captured:', event)
      },
    })
  }

  instance = Bugsnag
  return instance
}
